'use client';

import React from 'react';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { isBeforeKinofest, kinofestCinemas } from '@cineamo/ui/src/misc/kinofest/kinofest-constants';
import KinofestBanner from '@cineamo/ui/src/misc/kinofest/KinofestBanner';

import CenterLayout from '@cineamo/composables/src/CenterLayout';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

const KinofestBannerSection: React.FC = () => {
    const domainConfiguration: DomainConfigurationDto = useDomainConfiguration();
    const cinemaId = domainConfiguration?.cinema?.id;
    const isKinofestCinema = kinofestCinemas.includes(cinemaId);

    if (isBeforeKinofest && isKinofestCinema) {
        return (
            <section>
                <CenterLayout className="space-y-24">
                    <div className="flex flex-col w-full h-auto">
                        <KinofestBanner cinemaId={cinemaId} />
                    </div>
                </CenterLayout>
            </section>
        );
    }

    return null;
};

export default KinofestBannerSection;
